module.exports = __webpack_public_path__ + "static/media/jo.5a774ea7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/jo.svg
// module id = 158
// module chunks = 0